/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2023 Comcast Cable Communications Management, LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {} from '../Stage.js';
export class Platform {
    settings;
    glw = null;
    canvas = null;
    constructor(settings = {}) {
        // Apply default settings
        this.settings = {
            numImageWorkers: settings.numImageWorkers ?? 2,
            forceWebGL2: settings.forceWebGL2 ?? false,
            canvas: settings.canvas ?? null,
        };
        // If a canvas was provided in the settings, use it. Otherwise, create a new one.
        if (this.settings.canvas !== null) {
            this.canvas = this.settings.canvas;
        }
        else {
            this.canvas = this.createCanvas();
        }
    }
}
//# sourceMappingURL=Platform.js.map